// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-header {
  position: relative;
  overflow: hidden;
}

.login-header .cave {
  /* These are maximum dimensions: */
  width: 80%;
  height: 20vh;

  /* Center vertically & horizontally: */
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.login-header .sky {
  width: 100%;
  height: 40vh;
  background-color: #8cf;
}

.login-header .grass {

  border-radius: 50% / 100% 100% 0 0;
  top: 20vh;
  height: 20vh;
  position: absolute;
  width: 150%;
  margin-left: -25%;
  background-color: #6a2;
}

.loginView-grassTransition {
  height: 5vh;
  width: 100vw;
  position: absolute;
  top: 40vh;
}


.loginView-rays {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  outline: 1px solid black;
}


.loginView-rays svg {
  display: inline-block;
  position: relative;
  /* left:  calc(-10000px + 50vw); */
  right:  calc(10000px - 50vw);
  /* top:   -10000px; */
  bottom: calc(10000px - 50vh);

  width:  20000px;
  /* height: 20000px; */
  animation: spin 30s linear infinite;
}


.loginView-cloud {
  width: 15vh;
/*   outline: 1px solid black; */
  display: inline-block;
  padding: 20px;
  position: absolute;
  left: -15vh;
  top: 3vh;
  animation: drift 100s linear infinite;
}


@keyframes spin {
	from { transform: rotate(0deg); }
	to { transform: rotate(-360deg); }
}


@keyframes drift {
  from {transform: translate(0);}
  to {transform: translate(100vw);}
}

.login-dirt {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60vh; /*Header took 40, so take remaining*/
  /* background-image: url("../public/exportedDirt.svg"); */
  background-color: #6b3f12;
  background-repeat: repeat;
}

.login-dirt .login-form {
  /* background-color: #6b3f12; */
  box-shadow: 0 0 10px 0px black;

  background-color: #2c1704;
  color: white;
}


/* Override the button colors: */
.login-view .btn {
  background-color: #ffb700;
}
.login-view .btn-text {
  background: none;
  color: #ffb700;
}
.login-view .label {
  color: #ffb700;
}

.login-view .txtbox {
  background-color: #fff1;
  color: white;
  font-size: 1.25rem;
  padding: 10px 10px 5px 10px;
  border: none;
  border-bottom: 1px solid white;
  box-sizing: border-box;
  caret-color: #ffb700;
}


.login-view .txtbox:focus {
  outline: none;
  border-bottom: 2px solid #ffb700;
  padding-bottom: 4px;
  border-color: #ffb700;
}

.login-view .txtbox.invalid {
  border-bottom-color: red;
}

.login-view .txtbox.valid {
  border-bottom-color: #0f0;
}

.login-view .txtbox::placeholder {
  opacity: 0.6;
}

.login-view input {
  width: 100%;
}

.login-name-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
}

.login-roomcode-container input {
  max-width: 5em;
  flex-grow: 1;
  text-transform: uppercase;
}

.login-roomcode-container button {
  margin-left: 15px;
  padding: 10px 15px;
}

.login-roomcode-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
}

.login-view hr {
  margin-top: 30px;
  border: none;
  border-bottom: 1px solid #fff2;
}
`, "",{"version":3,"sources":["webpack://./src/style/login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,UAAU;EACV,YAAY;;EAEZ,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,wBAAwB;AAC1B;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;;EAE5B,eAAe;EACf,qBAAqB;EACrB,mCAAmC;AACrC;;;AAGA;EACE,WAAW;AACb,gCAAgC;EAC9B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,qCAAqC;AACvC;;;AAGA;CACC,OAAO,uBAAuB,EAAE;CAChC,KAAK,0BAA0B,EAAE;AAClC;;;AAGA;EACE,MAAM,uBAAuB,CAAC;EAC9B,IAAI,2BAA2B,CAAC;AAClC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAE,oCAAoC;EAClD,yDAAyD;EACzD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;;EAE9B,yBAAyB;EACzB,YAAY;AACd;;;AAGA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC","sourcesContent":[".login-header {\n  position: relative;\n  overflow: hidden;\n}\n\n.login-header .cave {\n  /* These are maximum dimensions: */\n  width: 80%;\n  height: 20vh;\n\n  /* Center vertically & horizontally: */\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.login-header .sky {\n  width: 100%;\n  height: 40vh;\n  background-color: #8cf;\n}\n\n.login-header .grass {\n\n  border-radius: 50% / 100% 100% 0 0;\n  top: 20vh;\n  height: 20vh;\n  position: absolute;\n  width: 150%;\n  margin-left: -25%;\n  background-color: #6a2;\n}\n\n.loginView-grassTransition {\n  height: 5vh;\n  width: 100vw;\n  position: absolute;\n  top: 40vh;\n}\n\n\n.loginView-rays {\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  width: 100vw;\n  height: 100vh;\n  outline: 1px solid black;\n}\n\n\n.loginView-rays svg {\n  display: inline-block;\n  position: relative;\n  /* left:  calc(-10000px + 50vw); */\n  right:  calc(10000px - 50vw);\n  /* top:   -10000px; */\n  bottom: calc(10000px - 50vh);\n\n  width:  20000px;\n  /* height: 20000px; */\n  animation: spin 30s linear infinite;\n}\n\n\n.loginView-cloud {\n  width: 15vh;\n/*   outline: 1px solid black; */\n  display: inline-block;\n  padding: 20px;\n  position: absolute;\n  left: -15vh;\n  top: 3vh;\n  animation: drift 100s linear infinite;\n}\n\n\n@keyframes spin {\n\tfrom { transform: rotate(0deg); }\n\tto { transform: rotate(-360deg); }\n}\n\n\n@keyframes drift {\n  from {transform: translate(0);}\n  to {transform: translate(100vw);}\n}\n\n.login-dirt {\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 60vh; /*Header took 40, so take remaining*/\n  /* background-image: url(\"../public/exportedDirt.svg\"); */\n  background-color: #6b3f12;\n  background-repeat: repeat;\n}\n\n.login-dirt .login-form {\n  /* background-color: #6b3f12; */\n  box-shadow: 0 0 10px 0px black;\n\n  background-color: #2c1704;\n  color: white;\n}\n\n\n/* Override the button colors: */\n.login-view .btn {\n  background-color: #ffb700;\n}\n.login-view .btn-text {\n  background: none;\n  color: #ffb700;\n}\n.login-view .label {\n  color: #ffb700;\n}\n\n.login-view .txtbox {\n  background-color: #fff1;\n  color: white;\n  font-size: 1.25rem;\n  padding: 10px 10px 5px 10px;\n  border: none;\n  border-bottom: 1px solid white;\n  box-sizing: border-box;\n  caret-color: #ffb700;\n}\n\n\n.login-view .txtbox:focus {\n  outline: none;\n  border-bottom: 2px solid #ffb700;\n  padding-bottom: 4px;\n  border-color: #ffb700;\n}\n\n.login-view .txtbox.invalid {\n  border-bottom-color: red;\n}\n\n.login-view .txtbox.valid {\n  border-bottom-color: #0f0;\n}\n\n.login-view .txtbox::placeholder {\n  opacity: 0.6;\n}\n\n.login-view input {\n  width: 100%;\n}\n\n.login-name-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  width: 100%;\n}\n\n.login-roomcode-container input {\n  max-width: 5em;\n  flex-grow: 1;\n  text-transform: uppercase;\n}\n\n.login-roomcode-container button {\n  margin-left: 15px;\n  padding: 10px 15px;\n}\n\n.login-roomcode-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  width: 100%;\n}\n\n.login-view hr {\n  margin-top: 30px;\n  border: none;\n  border-bottom: 1px solid #fff2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
